import React__default from 'react';
import PropTypes__default from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';
import StreamlineIcon from './StreamlineIcon.js';
import SvgArrowLeft1 from '../../common/streamlinehq/img/streamline-regular/arrows-diagrams/arrows/arrow-left-1.svg.js';

var useStyles = makeStyles(function (theme) {
  return {
    arrowLeftIcon: {
      fontSize: theme.spacing(2.75),
      padding: theme.spacing(0.25)
    }
  };
});
var ArrowBackIcon = function ArrowBackIcon(_ref) {
  var className = _ref.className,
    onClick = _ref.onClick;
  var classes = useStyles();
  return /*#__PURE__*/React__default.createElement(StreamlineIcon, {
    className: clsx(classes.arrowLeftIcon, className),
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement(SvgArrowLeft1, null));
};
ArrowBackIcon.defaultProps = {};
ArrowBackIcon.propTypes = {
  className: PropTypes__default.string,
  onClick: PropTypes__default.func
};

export { ArrowBackIcon as default };
//# sourceMappingURL=ArrowBackIcon.js.map
